import React,{Fragment, useContext } from 'react'
import './styles/_getStarted.scss'
import { InfoContext } from '../../../context/Context';  
import CheckPoints from './CheckPoints';

export default function Started() {
    const { data } = useContext(InfoContext);
  return (
    <section id="cic-check-container">
        <div id="cic-content-container">
            <div className="cic-content-title1">
                <h2 className="text-left">What will you need to get started on your {data.momentFeed.locality}, {data.momentFeed.state_min} loan application?</h2>
            </div>
            <div className="cic-content-title2">
                <p className="cic-heading-4"></p>
            </div>
            <div className="cic-content-info2">
                 <CheckPoints />
            </div>
        </div>
    </section>

  )
}
